module.exports = __webpack_public_path__ + "img/icon-school7.ea698dba.png";